import { Component, inject, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@welty/ui';
import { ModalRef, MODAL_REF_TOKEN } from '../../services/modal-ref';
import { LucideIconsModule } from '../../icons/lucide-icons.module';
import { modalFadeAnimation } from '../../animations/modal.animations';

/** Normalized error payload for display (from HTTP error response). */
export interface ErrorModalData {
  statusCode: number;
  statusText?: string;
  errorCode?: string;
  message: string;
  path?: string;
  timestamp?: string;
  /** Any extra keys from the backend (e.g. details, validation errors). */
  extra?: Record<string, unknown>;
}

@Component({
  selector: 'app-error-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonComponent, LucideIconsModule],
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.scss',
  animations: [modalFadeAnimation],
})
export class ErrorModalComponent implements AfterViewInit {
  modalRef = inject<ModalRef<void>>(MODAL_REF_TOKEN);
  private readonly cdr = inject(ChangeDetectorRef);

  payload: ErrorModalData = {
    statusCode: 0,
    message: '',
  };

  animationState: 'open' | 'closed' | 'void' = 'void';
  technicalDetailsOpen = false;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.animationState = 'open';
      this.cdr.detectChanges();
    });
  }

  close(): void {
    this.animationState = 'closed';
  }

  toggleTechnicalDetails(): void {
    this.technicalDetailsOpen = !this.technicalDetailsOpen;
  }

  onAnimationDone(event: { toState: string }): void {
    if (event.toState === 'closed') {
      this.modalRef.close();
    }
  }

  get messageLines(): string[] {
    const m = this.payload.message;
    if (typeof m !== 'string') return [];
    if (!m) return [];
    return m
      .split('\n')
      .map((s) => s.trim())
      .filter(Boolean);
  }

  objectKeys(obj: Record<string, unknown>): string[] {
    return Object.keys(obj ?? {});
  }
}
